module.exports = __webpack_public_path__ + "static/media/screen-location-lowerleft.00ec6852.svg";